import { LazyMotion, MotionConfig } from "motion/react";
import type { ReactNode } from "react";
import { EASE } from "./presets";

/** After the page's own load, so the engine never shares a slow connection with the first paint. */
const afterLoad = () =>
  new Promise<void>((resolve) => {
    if (document.readyState === "complete") resolve();
    else window.addEventListener("load", () => resolve(), { once: true });
  });

const loadFeatures = () => afterLoad().then(() => import("./features")).then((module) => module.domMax);

/**
 * The motion layer (TDD-SA FR-SA-200, design note salon-booking-premium-redesign.md section 5.4).
 *
 * `LazyMotion` with the features fetched on demand keeps the animation engine out of the bundle that
 * paints the salon's name (NFR-SA-009). Until it arrives every `m.*` element renders in its final
 * place, so nothing waits on it. `strict` refuses the full `motion.*` components, which would pull the
 * whole engine back in. `reducedMotion="user"` drops transforms for anyone who has asked their system
 * for less motion, keeping only fades.
 */
export function MotionProvider({ children }: { children: ReactNode }) {
  return (
    <LazyMotion features={loadFeatures} strict>
      <MotionConfig reducedMotion="user" transition={{ duration: 0.45, ease: EASE }}>
        {children}
      </MotionConfig>
    </LazyMotion>
  );
}
